import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import { Elements } from 'react-stripe-elements';
import Responsive from 'react-responsive';
import * as util from '../../utils/util';
import GateFeeProcessing from './GateFeeProcessing';
// import StickyHeader from '../../components/onboarding/StickyHeader';
import StepsHeader from '../../components/header/StepsHeader';
import Modal from 'react-responsive-modal';
import * as zenscroll from 'zenscroll';
import Api from '../../utils/api';

import './GateFee.css';

class GateFee extends Component {
    constructor() {
        super();

        this.state = {
            selectedGenderId: null,
            showThankYou: false,
            firstName: '',
            lastName: '',
            phoneNumber: '',
            email: '',
            verAlt: false,
            openPhoneConfirmModal: false,
            phoneCountry: '',
        }

        this.showThankYou = this.showThankYou.bind(this);
        this.closePhoneConfirmModal = this.closePhoneConfirmModal.bind(this);
    }

    componentWillMount() {
        const userId = localStorage.getItem("user_id");
        if (!userId) {
            this.props.history.push('/signin');
        } else {
            if (localStorage.getItem('temp_new_user_flag')) {
                localStorage.removeItem('temp_new_user_flag');
            }

            if(localStorage.getItem("gateFeePaid")  == "true" ){
                this.setState({ showThankYou: true })
            }else{
                this.checkIfPaidGateFee();
            }

            this.getAccountInfo();

            var user_account_info = localStorage.getItem("user_account_info");
            if(util.isJSON(user_account_info)){
               let user_account_infoJson = JSON.parse(user_account_info);
               const phoneCountry = util.transformationCountryNumber(user_account_infoJson.region ? user_account_infoJson.region.id : 1);
               this.setState({
                phoneCountry: util.transformationCountryNumber(user_account_infoJson.region ? user_account_infoJson.region.id : 1) 
               })
               localStorage.setItem("phoneCountry",phoneCountry);
               localStorage.setItem("phoneCountryNumber",user_account_infoJson.region ? user_account_infoJson.region.id : 1);
            }

        }
    }
    componentDidMount() {
        document.documentElement.scrollTop = 0
    }

    checkIfPaidGateFee() {
        const userId = localStorage.getItem("user_id");
        fetch('/api/user-flags/gate-fee-paid?user-id=' + userId, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-auth-token': Api.auth_tokenManager()
            }
        })
        .then((response) => response.json()).then(responseJson => {
            if (responseJson) {
                this.setState({ showThankYou: true }, ()=>{
                    setTimeout(() => {
                        let anchor = document.getElementById("chat-button");
                        zenscroll.center(anchor);
                    }, 2000);
                });
                this.setState({ openPhoneConfirmModal: false })
                localStorage.setItem("gateFeePaid",true);
            }else{
                this.setState({ openPhoneConfirmModal: true })
            }
        })
        .catch(function(err) {
            console.log("There was a problem checking payment status. Please try again.");
        });
    }

    directToLandingPage() {
        const phoneNumber = this.state.phoneNumber;
        if (phoneNumber) {
          const phoneNumberLength = phoneNumber.length;
          if (phoneNumber[phoneNumberLength - 1] > 4) {
              this.setState({ verAlt: true });
          } else {
              return;
          }
        } else {
          return;
        }

    }

    formatPhoneNumber(phoneNumberString) {
        let cleaned = ('' + phoneNumberString).replace(/\D/g, '')
        if(this.state.phoneCountry == "UK"){
            return cleaned;
        }else{
            let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
            if (match) {
                return '(' + match[1] + ') ' + match[2] + '-' + match[3];
            }
        }
        return null;
    }

    //Get user name, email, and phone number
    getAccountInfo() {
        const userId = localStorage.getItem("user_id");
        fetch('/api/user-account-info/' + userId, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-auth-token': Api.auth_tokenManager()
            }
        }).then((response) => response.json()).then(responseJson => {
            this.setState({
                selectedGenderId: responseJson.gender && responseJson.gender.id,
                firstName: responseJson.firstName,
                lastName: responseJson.lastName,
                email: responseJson.email,
                phoneNumber: this.formatPhoneNumber(responseJson.phoneNumber),
                // phoneNumber: responseJson.phoneNumber,最简单的就是去除电话验证
            }, () => {
                this.directToLandingPage();
            });
        }).catch(function(err) {
            console.log("There is a problem to get the account info. Please try again.");
        });
    }

    showThankYou() {
        this.setState({ showThankYou: true });
        this.setState({ openPhoneConfirmModal: false })
    }

    closePhoneConfirmModal() {
        this.setState({ openPhoneConfirmModal: false });
    }

    openPhoneConfirmUrl(){
        window.location.href = 'https://mailchi.mp/helloava/freeconsultation';
    }

    componentDidUpdate(prevProps, prevState) {

        if(window.location.pathname != "/recommendation-thank"){
            if (this.state.showThankYou === true) {
                if(window.location.pathname != "/recommendation-thank"){
                    window.location.pathname = "/recommendation-thank"
                }
            }
        }
    }

    render() {
        // const userFirstName = localStorage.getItem('user_firstname');

        return (
            <div id="gate-fee">
                {/*<div style={this.state.selectedGenderId === 2 ? {backgroundImage: "url('/images/onboarding/skinprofile/male-profile.svg')"} : this.state.selectedGenderId === 1 || this.state.selectedGenderId === 3 ? {backgroundImage: "url('/images/onboarding/skinprofile/female-profile.svg')"} : null} className="welcome-section">
                    <div className="messages">
                        <div className="name">Hi { userFirstName }! </div>
                    </div>
                </div>*/}
                {/*<div id="links">
                    <div id="links-section" className="links-section">
                        {/*<StickyHeader
                            page="right"
                            left="SKIN PROFILE"
                            right="RECOMMENDATIONS"
                            leftLink="/survey-result"
                            rightLink="/recommendation-landing"
                        />
                    </div>
                </div>*/}
                {
                   this.state.showThankYou ?
                   <StepsHeader step={3} /> :
                   <StepsHeader step={2} />
                }
                <div className="gate-fee-body">
                    <div style={ this.state.verAlt ? { flexDirection: "column-reverse" } : null } className="gate-fee-test-container">
                        <div className="test-section test-section-1">
                        
                            <div className="gate-fee-section gate-fee-header" style={ window.location.pathname == "/recommendation-thank"?{display:'none'}:{}}>
                                <h1>Your skin advisor is working on your recommendations!</h1>
                            </div>

                            <div className="gate-fee-section gate-fee-what-you-get" style={ window.location.pathname == "/recommendation-thank"?{display:'none'}:{}}>
                                <div className="what-will-you-get-content">
                                    <h2>What will you get?</h2>

                                    <div className="block">
                                        <img alt="Check" src="/images/gate/check-icon.svg" />
                                        <div className="column">
                                            <div className="title"> <span style={{fontWeight:'blod'}}> Live video consultation </span>  with one of our licensed estheticians, certified by NYS Esthetics Licensing Board</div>
                                        </div>
                                    </div>

                                    <div className="block">
                                        <img alt="Check" src="/images/gate/check-icon.svg" />
                                        <div className="column">
                                            <div className="title"><span>Skincare products</span> that are curated for your needs and skin type</div>
                                        </div>
                                    </div>
                                    <div className="block">
                                        <img alt="Check" src="/images/gate/check-icon.svg" />
                                        <div className="column">
                                            <div className="title">A <span>personalized regimen card</span> that tells you how to use your products step-by-step</div>
                                        </div>
                                    </div>
                                    
                                    <div className="block">
                                        <img alt="Check" src="/images/gate/check-icon.svg" />
                                        <div className="column">
                                            <div className="title">Product refills at <span>10% off</span></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="what-will-you-get-image">
                                    <img alt="HelloAva - What will you get?" src="https://res.cloudinary.com/dhybuxeqg/image/upload/f_auto/v1601979648/hello/images/explain/section3/rec-landing_swdjkm.png" />
                                </div>
                            </div>
                     

                            
                         
                            <div className="gate-fee-section gate-fee-risk-free" style={ window.location.pathname == "/recommendation-thank"?{display:'none'}:{}}>
                                <h2>Get Better Skin with No Risk</h2>
                                <div className="gate-fee-risk-free-blocks">
                                    <div className="risk-free-row">
                                        <div className="risk-free-block">
                                            <div className="risk-free-content">
                                                <img alt="We'll match your budget" className="img_credit" src="/images/explain/section4/credit.svg" />
                                                <div className="risk-free-content-text">
                                                    <h3>$10 video consultation fee will be credited towards your purchase</h3>
                                                </div>
                                            </div>
                                            <div className="risk-free-square" />
                                        </div>
                                        <div className="risk-free-block">
                                            <div className="risk-free-content">
                                                <img alt="No subscription" className="img_risk" src="/images/explain/section4/risk.svg" />
                                                <div className="risk-free-content-text">
                                                    <h3 style={{marginBottom:'8px'}}>Risk-free skin consultation</h3>
                                                    {/* <div className="sub-note">
                                                        <div>If you aren’t happy with your</div>
                                                        <div>recommendations, we will</div>
                                                        <div>refund you the $10</div>
                                                    </div> */}
                                                </div>
                                            </div>
                                            <div className="risk-free-square" />
                                        </div>
                                        
                                    </div>
                                    <div className="risk-free-row">
                                        <div className="risk-free-block">
                                            <div className="risk-free-content">
                                                <img className="img_match" alt="Skincare consultation fee credited towards your purchase" src="/images/explain/section4/match.svg" />
                                                <div className="risk-free-content-text">
                                                    <h3>We’ll match<br/>your budget</h3>
                                                </div>
                                            </div>
                                            <div className="risk-free-square" />
                                        </div>
                                        <div className="risk-free-block">
                                            <div className="risk-free-content">
                                                <img className="img_subscr" alt="Free returns, risk free" src="/images/explain/section4/subscription.svg" />
                                                <div className="risk-free-content-text">
                                                    <h3>No subscription required</h3>
                                                </div>
                                            </div>
                                            <div className="risk-free-square" />
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                        <div className="test-section test-section-2">
                            <div id="gate-fee-checkout-section" className="gate-fee-section gate-fee-checkout-section">
                                {
                                    !this.state.showThankYou ?
                                    <div>
                                        <h2>You're almost there!</h2>
                                        <div id="you-subtitle" className="subtitle">A few more steps before you’re on your way toward better skin</div>
                                    </div> :
                                    <h2 id="you-subtitle">You are all set!</h2>
                                }
                                <Elements>
                                    <GateFeeProcessing 
                                        showThankYou={ this.showThankYou }
                                        showThankYouMessage={ this.state.showThankYou }
                                        firstName={ this.state.firstName }
                                        lastName={ this.state.lastName }
                                        phoneNumber={ this.state.phoneNumber }
                                        email={ this.state.email }
                                    />
                                </Elements>
                                {
                                    this.state.showThankYou ?
                                    <div className="thank-you-next-blocks">
                                        <div className="thank-you-next-block first">
                                            <div className="thank-you-next-title">
                                                <h3>Schedule the consultation</h3>
                                            </div>
                                            <div className="thank-you-next-body">
                                                <p>
                                                    Schedule your video consultation now or wait for your skin advisor to reach out.
                                                </p>
                                                <div className="thank-you-next-note">Our normal business hours are Monday-Friday 9:00 am-8:00 pm EST</div>
                                            </div>
                                        </div>

                                    {/*                                             
                                        <div className="thank-you-arrow">
                                            &#8594;
                                        </div>
                                        <div className="thank-you-next-block second">
                                            <div className="thank-you-next-title">
                                                <h3>Make a decision within 3 days</h3>
                                            </div>
                                            <div className="thank-you-next-body">
                                                <p>
                                                    You can decide on what you want within 3 days with your skin advisor or opt out of your purchase. No payment will be made until you confirm your product recommendations.
                                                </p>
                                            </div>
                                        </div> 
                                    */}



                                        <div className="thank-you-arrow">
                                            &#8594;
                                        </div>
                                        <div className="thank-you-next-block">
                                            <div className="thank-you-next-title">
                                                <h3>Free shipping (on orders in the US over $50) and refill at 10% off</h3>
                                            </div>
                                            <div className="thank-you-next-body">
                                                <p>
                                                    Easy breezy! Fan of the products? Refill anytime with a discount.
                                                </p>
                                            </div>
                                        </div>
                                    </div> :
                                    null
                                }
                            </div>
                        </div>
                    </div>
                    <div className="gate-fee-section gate-fee-skin-advisors">
                        <h2>Expert skin advice and recommendations</h2>
                        <div className="skin-advisor-blocks" id="skin-advisor-blocks">
                            <div className="gate-fee-block skin-advisor-block team-image">
                                <Responsive minWidth={ 813 }>
                                    <img alt="Skin advising team - HelloAva" src="/images/explain/section5/team.png" />
                                </Responsive>
                                <Responsive maxWidth={ 812 }>
                                <div className="our-process-block skin-advisor-block mobile-image">
                                    <div className="mobile-image-container">
                                        <img alt="Bianca Richard" src="/images/explain/section5/team-mobile-1.png" />
                                    </div>
                                    <div className="advisor-name">Kathleen Callahan</div>
                                    <div className="advisor-title">Licensed Esthetician</div>
                                </div>
                                <div className="our-process-block skin-advisor-block mobile-image">
                                    <div className="mobile-image-container">
                                        <img alt="Frannelys Diaz" src="/images/explain/section5/team-mobile-2.png" />
                                    </div>
                                    <div className="advisor-name">Kimberley Broomes</div>
                                    <div className="advisor-title">Licensed Esthetician</div>
                                </div>
                                <div className="our-process-block skin-advisor-block mobile-image">
                                    <div className="mobile-image-container">
                                        <img alt="Lian Mack, MD" src="/images/explain/section5/team-mobile-3.png" />
                                    </div>
                                    <div className="advisor-name">Lian Mack, MD</div>
                                    <div className="advisor-title">Board Certified Dermatologist</div>
                                </div>
                            </Responsive>
                            </div>
                            <div className="gate-fee-block skin-advisor-block ">
                                <div className="subtitle">Have any questions about your products, routine, or skincare in general? Need to make any changes to your recommendations? Our dedicated skincare advisory team is here to tailor a regimen for you.</div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* <div className="phone-confirm-modal" style={this.state.openPhoneConfirmModal?{display:'block'}:{display:'none'}}>
                    <i className="phone-modal-closeIcon" onClick={()=>{  this.closePhoneConfirmModal() }}>x</i>
                    <div className="phone-confirm-top-title" onClick={()=>{ this.openPhoneConfirmUrl()  }}>
                        <div className="phone-modal-top-img-text">
                            <img src="/images/gate/hua.png" className="phone-modal-img"/>
                            <div>Limited time only:</div>
                        </div>
                        <div className="phone-font-blod">your consultation fee is waived</div>
                    </div>
                    <div className="bottom-array-over">see more</div>
                </div>
            */}

            </div>
        );
    }
}

export default withRouter(GateFee);



// WEBPACK FOOTER //
// ./src/views/onboarding/GateFee.js